<ng-container *transloco="let t; read: 'user'">
  <div class="rounded-lg fix-action-row modal-body">
    <div class="flex justify-between border-b">
      <h1 class="text-[25px] font-bold">{{ label }}</h1>
      <i
        mat-button
        mat-dialog-close
        class="text-drdpblue-300 cursor-pointer uil uil-times-circle"
      ></i>
    </div>
    <div mat-dialog-content>
      <form
        class="grid grid-cols-2 gap-4 gap-x-10 p-3 gridCust"
        [formGroup]="transferChildForm"
        >
        @if (isBatchTransfer) {
          <div class="col-span-2 mt-2">
            <label class="font-normal mb-2" for="childName"
              >{{ t('manageEnrollment.common.selectedChildren') }}</label
              >
              <ul>
                @for (child of students; track child) {
                  <li>
                    <!-- Server-supplied: child name comes from the API. -->
                    {{ child.firstName + " " + child.lastName }}
                  </li>
                }
              </ul>
            </div>
          }
          @if (!isBatchTransfer) {
            <div class="col-span-1 mt-2">
              <label class="font-normal mb-2" for="childName">{{
                t('manageEnrollment.common.childName')
              }}</label>
              <p>
                <!-- Server-supplied: child name comes from the API. -->
                {{ child.firstName + " " + child.lastName }}
              </p>
            </div>
          }
          <div class="col-span-1">
            <drdp-select-rating-period
              [initialRatingPeriodId]="ratingPeriod.value"
              [label]="t('manageEnrollment.transferChild.ratingPeriodLabel')"
              (ratingPeriod)="handleRatingPeriod($event)"
              [agencyId]="agencyId"
              [required]="true"
              [omitFutureRps]="true"
              >
            </drdp-select-rating-period>
          </div>
          <div class="col-span-1">
            <drdp-select-site
              [initialSiteId]="site.value"
              [label]="t('manageEnrollment.transferChild.siteLabel')"
              (site)="handleSite($event)"
              [agencyId]="agencyId"
              [multiSelect]="false"
              [multiSelectInitVals]="false"
              [required]="true"
              >
            </drdp-select-site>
          </div>
          <div class="col-span-1">
            <drdp-select-class
              [initialClassroomId]="classroom.value"
              [label]="t('manageEnrollment.transferChild.classroomLabel')"
              (classroom)="handleClassroom($event)"
              [siteIds]="site.value"
              [ratingPeriodId]="ratingPeriod.value"
              [multiSelect]="false"
              [required]="true"
              >
            </drdp-select-class>
          </div>
          @if (isSoftImplementation || show2025) {
            <div class="col-span-1 self-end">
              <drdp-select-age-grade
                [stateId]="stateId" [label]="t('manageEnrollment.common.ageGradeLabel')"
                [multiSelect]="false"
                [required]="true"
                [isPilot]="true"
                [schoolYearId]="targetSchoolYearId"
                (ageGrade)="handleAgeGrade($event)">
              </drdp-select-age-grade>
            </div>
          }
          <div class="relative">
            <div class="col-span-1">
              <drdp-date-picker [label]="t('manageEnrollment.common.classroomEnrollmentDateLabel')"
                labelClasses="pb-1"
                [isRequired]="true"
                (emitDate)="handleDate($event)">
              </drdp-date-picker>
              @if (classEnrollmentDate.hasError('exitDate')) {
                <mat-error class="text-xs">
                  {{ t('manageEnrollment.transferChild.exitDateError') }}
                </mat-error>
              }
              @if (classEnrollmentDate.hasError('dateRange')) {
                <mat-error class="text-xs">
                  {{ t('manageEnrollment.transferChild.dateRangeError') }}
                </mat-error>
              }
            </div>
            <div class="absolute top-0 left-full mt-1 ml-[-2px]">
              <i class="uil uil-info-circle text-xs" [matTooltip]="t('manageEnrollment.common.enrollmentDateInfo')"></i>
            </div>
          </div>
          <div class="col-span-2 w-full">
            <mat-form-field class="bg-white" appearance="fill">
              <label for="Comment" class="font-normal block mb-2 text-md">
                {{ t('manageEnrollment.common.commentLabel') }}
              </label>
              <input
                matInput
                [placeholder]="t('manageEnrollment.common.commentLabel')"
                type="text"
                formControlName="Comment"
                [maxLength]="150"
                />
            </mat-form-field>
          </div>
        </form>
        <div class="p-3">
          <drdp-rating-periods [agencyId]="agencyId"></drdp-rating-periods>
        </div>
      </div>
      <div mat-dialog-actions class="flex justify-end">
        <drdp-btn color="cancel" mat-button mat-dialog-close>{{ t('manageEnrollment.common.cancel') }}</drdp-btn>
        <drdp-btn
          class="ml-3"
          mat-button
          [disabled]="transferChildForm.invalid || isProcessing"
          cdkFocusInitial
          (click)="onSubmit()"
          >
          {{ submitBtnText }}</drdp-btn
          >
        </div>
      </div>
</ng-container>
